// created helper for mass inport of screens for router to save space
import AccountControlsScreen from "../screens/AccountControlsScreen/AccountControlsScreen";
import AccountScreen from "../screens/AccountScreen/AccountScreen";
import AccountVerificationScreen from "../screens/AccountVerificationScreen/AccountVerificationScreen";
import AsianCompetitionsScreen from "../screens/AsianEventsScreen/screens/AsianCompetitionsScreen/AsianCompetitionsScreen";
import AsianOpenBetsScreen from "../screens/AsianOpenBetsScreen/AsianOpenBetsScreen";
import AsianStatementScreen from "../screens/AsianStatementScreen/AsianStatementScreen";
import AuthScreen from "../screens/AuthScreen/AuthScreen";
import BetDrawerScreen from "../screens/EventsScreen/screens/BetDrawerScreen/BetDrawerScreen";
import CompetitionsScreenWrapper from "../screens/EventsScreen/screens/CompetitionScreenWrapper/CompetitionsScreenWrapper";
import EventDetailScreen from "../screens/EventsScreen/screens/EventDetailScreen/EventDetailScreen";
import EventFavoritesScreen from "../screens/EventsScreen/screens/EventFavoritesScreen/EventFavoritesScreen";
import HelpAndLearningAboutUsLicenceInformation from "../screens/HelpAndLearningScreen/AboutUs/LicenceInformation";
import HelpAndLearningContactAndSupportContactUs from "../screens/HelpAndLearningScreen/ContactAndSupport/ContactUs";
import HelpAndLearningFaqsBetting from "../screens/HelpAndLearningScreen/Faqs/Betting";
import HelpAndLearningFaqsFunding from "../screens/HelpAndLearningScreen/Faqs/Funding";
import HelpAndLearningFaqsMyAccount from "../screens/HelpAndLearningScreen/Faqs/MyAccount";
import HelpAndLearningGettingStartedFundingYourAccount from "../screens/HelpAndLearningScreen/GettingStarted/FundingYourAccount";
import HelpAndLearningGettingStartedOurOdds from "../screens/HelpAndLearningScreen/GettingStarted/OurOdds";
import HelpAndLearningGettingStartedPlacingABet from "../screens/HelpAndLearningScreen/GettingStarted/PlacingABet";
import HelpAndLearningGettingStartedQuickLinks from "../screens/HelpAndLearningScreen/GettingStarted/QuickLinks";
import HelpAndLearningScreen from "../screens/HelpAndLearningScreen/HelpAndLearningScreen";
import HelpAndLearningResponsibleGaming from "../screens/HelpAndLearningScreen/ResponsibleGaming/ResponsibleGaming";
import HelpAndLearningRulesAndRegulationsCodeOfConduct from "../screens/HelpAndLearningScreen/RulesAndRegulations/CodeOfConduct";
import HelpAndLearningRulesAndRegulationsMarketRules from "../screens/HelpAndLearningScreen/RulesAndRegulations/MarketRules";
import HelpAndLearningRulesAndRegulationsSportsRules from "../screens/HelpAndLearningScreen/RulesAndRegulations/SportsRules";
import HelpAndLearningSelfExclusion from "../screens/HelpAndLearningScreen/SelfExclusion/SelfExclusion";
import HelpAndLearningTermsAndConditionsPrivacyPolicy from "../screens/HelpAndLearningScreen/TermsAndConditions/PrivacyPolicy";
import HelpAndLearningTermsAndConditions from "../screens/HelpAndLearningScreen/TermsAndConditions/TermsAndConditions";
import HelpAndLearningWelcomeHelpAndLearning from "../screens/HelpAndLearningScreen/Welcome/Welcome";
import {
  default as AsianFunding,
  default as ManageFundingScreen,
} from "../screens/ManageFundingScreen/ManageFundingScreen";
import ProfileScreen from "../screens/ProfileScreen/ProfileScreen";
import PublicScreen from "../screens/PublicScreen/PublicScreen";
import RedirectToLogin from "../screens/RedirectToLogin/RedirectToLogin";
import RegisterScreen from "../screens/RegisterScreen/RegisterScreen";
import ReportsScreen from "../screens/ReportsScreen/ReportsScreen";
export const ImportModule = {
  AuthScreen: AuthScreen,
  RegisterScreen: RegisterScreen,
  RedirectToLogin: RedirectToLogin,
  HelpAndLearningScreen: HelpAndLearningScreen,
  CompetitionsScreenWrapper: CompetitionsScreenWrapper,
  CompetitionsScreenMobile: CompetitionsScreenWrapper,
  HelpAndLearningWelcomeHelpAndLearning: HelpAndLearningWelcomeHelpAndLearning,
  HelpAndLearningGettingStartedFundingYourAccount:
    HelpAndLearningGettingStartedFundingYourAccount,
  HelpAndLearningGettingStartedPlacingABet:
    HelpAndLearningGettingStartedPlacingABet,
  HelpAndLearningGettingStartedOurOdds: HelpAndLearningGettingStartedOurOdds,
  HelpAndLearningGettingStartedQuickLinks:
    HelpAndLearningGettingStartedQuickLinks,
  HelpAndLearningRulesAndRegulationsSportsRules:
    HelpAndLearningRulesAndRegulationsSportsRules,
  HelpAndLearningRulesAndRegulationsMarketRules:
    HelpAndLearningRulesAndRegulationsMarketRules,
  HelpAndLearningRulesAndRegulationsCodeOfConduct:
    HelpAndLearningRulesAndRegulationsCodeOfConduct,
  HelpAndLearningContactAndSupportContactUs:
    HelpAndLearningContactAndSupportContactUs,
  HelpAndLearningFaqsMyAccount: HelpAndLearningFaqsMyAccount,
  HelpAndLearningFaqsFunding: HelpAndLearningFaqsFunding,
  HelpAndLearningFaqsBetting: HelpAndLearningFaqsBetting,
  HelpAndLearningAboutUsLicenceInformation:
    HelpAndLearningAboutUsLicenceInformation,
  HelpAndLearningResponsibleGaming: HelpAndLearningResponsibleGaming,
  HelpAndLearningSelfExclusion: HelpAndLearningSelfExclusion,
  HelpAndLearningTermsAndConditions: HelpAndLearningTermsAndConditions,
  HelpAndLearningTermsAndConditionsPrivacyPolicy:
    HelpAndLearningTermsAndConditionsPrivacyPolicy,
  AsianCompetitionsScreen: AsianCompetitionsScreen,
  AsianOpenBetsScreen: AsianOpenBetsScreen,
  AsianFunding: AsianFunding,
  AsianStatementScreen: AsianStatementScreen,
  EventDetailScreen: EventDetailScreen,
  BetDrawerScreen: BetDrawerScreen,
  EventFavoritesScreen: EventFavoritesScreen,
  ReportsScreen: ReportsScreen,
  ProfileScreen: ProfileScreen,
  AccountScreen: AccountScreen,
  AccountVerificationScreen: AccountVerificationScreen,
  ManageFundingScreen: ManageFundingScreen,
  PublicScreen: PublicScreen,
  AccountControlsScreen: AccountControlsScreen,
};
